import React, {useState, useEffect, useRef} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Sidebar} from "primereact/sidebar";

import _FM_VatgroupListComponent from "../components/_FM_vatgroup/_FM_VatgroupListComponent";
import _FM_VatgroupFormComponent from "../components/_FM_vatgroup/_FM_VatgroupFormComponent";
import _FM_VatgroupShowComponent from "../components/_FM_vatgroup/_FM_VatgroupShowComponent";
import HelpComponent from "../components/HelpComponent";

const _FM_VatgroupPage = (props) => {

  const {t, i18n} = props;
  const navigate = useNavigate();
  const {id,action, entity} = useParams();

  useEffect(() => {
    document.title = t('vatgroups') + ' - ' + process.env.REACT_APP_TITLE;
    window.App.help('/vat-group')
  }, []);

  return (
    <div className="_FM_VatgroupPage p-component p-m-lg-4">
      <HelpComponent type={"site"} position={"TOP_OF_THE_PAGE"} url={"/vat-group"}/>
      <Panel>
        <_FM_VatgroupListComponent />
      </Panel>
      <Sidebar position="right" visible={!entity && (action === 'create' || action === 'update')} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 navigate('/vat-group');
               }}>
        <_FM_VatgroupFormComponent />
      </Sidebar>
      <Sidebar position="right" visible={action === 'read'} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 navigate('/vat-group');
               }}>
        <_FM_VatgroupShowComponent />
      </Sidebar>
    </div>
  )
}
export default withTranslation('common')(_FM_VatgroupPage);
